// extracted by mini-css-extract-plugin
export default {"cookiesInfo":"style_cookiesInfo__A+kzR","buttons":"style_buttons__0xc2K"};